module.exports = __webpack_public_path__ + "img/images-3.5c1f819e.jpg";